import { BannerDirectiveModule } from '@b2c/common/directives/banner/banner.directive';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { EventsControllerModule } from './controllers/EventsController';
import { EventsDetailView } from './views/detail/detail';
import { EventsListView } from './views/list/list';
import { EventsReviewsView } from './views/reviews/reviews';
import { MobileNavigationDirectiveModule } from '@b2c/common/directives/mobileNavigation/mobileNavigation.directive';
import { PageDetailsDirectiveModule } from '@b2c/common/directives/page/details/details.directive';
import { PageHeadingDirectiveModule } from '@b2c/common/directives/page/heading/heading.directive';
import { HeaderDirectiveModule } from '@b2c/common/directives/header/header.directive';
import { FooterDirectiveModule } from '@b2c/common/directives/footer/footer.directive';
import { ReviewDirectiveModule } from '@b2c/common/directives/review/review.directive';
import { ReviewCreateDirectiveModule } from '@b2c/common/directives/review/create/create.directive';
import { MembershipHeadingDirectiveModule } from '@b2c/common/directives/membershipHeading/membershipHeading.directive';
import { RatingsDirectiveModule } from '@b2c/common/directives/ratings/ratings.directive';
import { ReviewsServiceModule } from '@b2c/common/services/reviews/reviews.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import { VerifyMemberResolver } from '@b2c/common/resolvers';

export const EventsView = angular.module( 'acme.view.events', [
  uiRouter,
  'ui.bootstrap',
  ThemesServiceModule,
  ReviewsServiceModule,
  HeaderDirectiveModule,
  FooterDirectiveModule,
  RatingsDirectiveModule,
  ReviewDirectiveModule,
  ReviewCreateDirectiveModule,
  PageHeadingDirectiveModule,
  PageDetailsDirectiveModule,
  MobileNavigationDirectiveModule,
  MembershipHeadingDirectiveModule,
  BannerDirectiveModule,
  EventsControllerModule,
  EventsListView,
  EventsDetailView,
  EventsReviewsView,
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var events = {
        name: 'events',
        url: '/events/:tenantId',
        abstract: true,
        views: {
          "main": {
            controller: 'EventsController',
            templateUrl: 'layouts/standard.tpl.html'
          }
        },
        resolve: {
          ThemesData: [ '$stateParams', 'ThemesService', function($stateParams, ThemesService) {
            return ThemesService.init($stateParams.tenantId);
          }],
          verifyMember: VerifyMemberResolver(),
          ReviewsSummaryData: [ '$stateParams', 'ReviewsService', function($stateParams, ReviewsService) {
            return ReviewsService.init($stateParams.tenantId);
          }]
        }
      },
      eventsDefault = {
        name: 'events.default',
        url: '',
        views: {
          "subview-main": {
            templateUrl: 'events.tpl.html'
          }
        },
        data: {
          pageTitle: 'Plan Your Visit · George Washington\'s Mount Vernon'
        }
      };

    $stateProvider
      .state(events)
      .state(eventsDefault);
}).name;
